import React from 'react'
import classNames from 'classnames'
import { Image } from 'baby-design'
import Link from 'components/link'
import { feedGuideViewerPath } from 'lib/urls'

import css from './FeedItemCard.styles.scss'

import { FeedItemCardProps } from './FeedItemCard.types'

const FeedItemCard: React.FC<FeedItemCardProps> = ({
  className,
  imageUrl,
  teaser,
  title,
  ctaText,
  guideLabel,
  postUrl,
  linkUrl,
}) => {
  const feedItemCardClasses = classNames(css.FeedItemCard, className)

  const isVideo = guideLabel === 'Video'

  return (
    <Link
      to={postUrl ? feedGuideViewerPath(postUrl) : undefined}
      url={postUrl ? undefined : linkUrl}
      routerVersion={4}
      newWindow={!postUrl}
      data-testid="feed-item-card-link"
    >
      <div className={feedItemCardClasses}>
        <div className={css.FeedItemCard__imageContainer}>
          {isVideo && (
            <Image
              className={css.FeedItemCard__videoOverlay}
              src="//images.babylist.com/image/upload/v1568235803/play_button_3x_sokilf.png"
              alt="Play video"
            />
          )}
          <Image
            className={classNames(css.FeedItemCard__image, {
              [css.FeedItemCard__video]: isVideo,
            })}
            alt={title}
            src={imageUrl}
          />
        </div>
        <div className={css.FeedItemCard__content}>
          <h3 className={css.FeedItemCard__title}>{title}</h3>
          <p className={css.FeedItemCard__teaser}>{teaser}</p>
          {ctaText && <p className={css.FeedItemCard__cta}>{ctaText}</p>}
        </div>
      </div>
    </Link>
  )
}

export default FeedItemCard
